import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
export function Button({
  children,
  className = '',
  ...props
}: ButtonProps) {
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`bg-teal hover:bg-teal-dark text-white font-bold py-4 px-8 rounded-full text-xl shadow-lg transition-colors flex items-center justify-center gap-2 ${className}`} {...props} data-id="element-143">
      {children}
    </motion.button>;
}